module.exports = __webpack_public_path__ + "img/banner_contact.38321467.png";